export default "__VITE_ASSET__BXZPakTV__"